// 表单参数类型
// (TEXT: 字符类型（默认类型）,
// PARAGRAPH: 段落，字符的另一种展示,
// DATE: 日期类型, OBJECT: 对象，一维数组,
// LIST: 对象 List，二维数组,
// ARRAY: 数组，可以用于标签场景，如  ["ABC", "BCD"])

export const FORM_VARIABLES_TYPE = {
  TEXT: 'TEXT',
  FILE: 'FILE',
  SELECT: 'SELECT',
  PARAGRAPH: 'PARAGRAPH',
  DATE: 'DATE',
  LIST: 'LIST',
  ARRAY: 'ARRAY',
  OBJECT: 'OBJECT',
  POPWINDOW: 'POPWINDOW',
  HIDDEN: 'HIDDEN'
}
// TJ("提交"),
// CXTJ("重新提交"),
// RL("认领"),
// QXRL("取消认领"),
// SP("审批"),
// WC("完成"),
// TH("退回"),
// CH("撤回"),
// ZC("暂存"),
// ZB("转办"),
// WP("委派"),
// ZZ("终止"),
// CC("抄送"),
// YY("已阅");
export const COMMENT_TYPE = {
  TJ: {
    NAME: '提交',
    VALUE: 'TJ'
  },
  CXTJ: {
    NAME: '重新提交',
    VALUE: 'CXTJ'
  },
  RL: {
    NAME: '认领',
    VALUE: 'RL'
  },
  QXRL: {
    NAME: '取消认领',
    VALUE: 'QXRL'
  },
  SP: {
    NAME: '审批',
    VALUE: 'SP'
  },
  WC: {
    NAME: '完成',
    VALUE: 'WC'
  },
  TH: {
    NAME: '退回',
    VALUE: 'TH'
  },
  CH: {
    NAME: '撤回',
    VALUE: 'CH'
  },
  ZC: {
    NAME: '暂存',
    VALUE: 'ZC'
  },
  ZB: {
    NAME: '转办',
    VALUE: 'ZB'
  },
  WP: {
    NAME: '委派',
    VALUE: 'WP'
  },
  ZZ: {
    NAME: '终止',
    VALUE: 'ZZ'
  },
  CC: {
    NAME: '抄送',
    VALUE: 'CC'
  },
  YY: {
    NAME: '已阅',
    VALUE: 'YY'
  }
}
// COMPLETE("同意`"),
//
// STOP("终止"),
//
// ASSIGN("转派"),
//
// DELEGATE("委派"),
//
// BACK("退回"),
//
// AKE_BACK("撤回");
export const DETAIL_BUTTON_TYPE = {
  COMPLETE: {
    NAME: '同意',
    VALUE: 'COMPLETE',
    alias: 'complete',
    icon: 'tongyi',
    bgColor: '#40A34A'
  },
  STOP: {
    NAME: '终止',
    VALUE: 'STOP',
    alias: 'stop',
    icon: 'jujue',
    bgColor: '#FC4E4E'
  },
  ASSIGN: {
    NAME: '转交',
    VALUE: 'ASSIGN',
    alias: 'assign',
    icon: 'zhongzhi',
    bgColor: '#8DABFF'
  },
  BACK: {
    NAME: '驳回',
    VALUE: 'BACK',
    alias: 'back',
    icon: 'a-tongyi2',
    bgColor: '#7654EE'
  },
  DELEGATE: {
    NAME: '加签',
    VALUE: 'DELEGATE',
    alias: 'delegate',
    icon: 'a-pinglun1',
    bgColor: '#F4A5CE'
  },
  REMINDER: {
    NAME: '催办',
    VALUE: 'REMINDER',
    alias: 'reminder',
    icon: 'a-tongyi3',
    bgColor: '#FDD004'
  },
  TAKE_BACK: {
    NAME: '撤销',
    VALUE: 'TAKE_BACK',
    alias: 'take_back',
    icon: 'a-tongyi1',
    bgColor: '#FF8600'
  },
  COMMENT: {
    NAME: '评论',
    VALUE: 'COMMENT',
    alias: 'comment',
    icon: 'pinglun1',
    bgColor: '#295EF5'
  },
  CIRCULATE: {
    NAME: '传阅',
    VALUE: 'CIRCULATE',
    alias: 'circulate',
    icon: 'circulate',
    bgColor: '#fce6ee',
    iconType: 'svg'
  },
  REVOKE: {
    NAME: '撤回',
    VALUE: 'REVOKE',
    alias: 'revoke',
    icon: 'revoke',
    bgColor: '#40A34A',
    iconType: 'svg'
  },
  MORE: {
    NAME: '更多',
    VALUE: 'MORE',
    alias: 'MORE',
    icon: 'gengduo-2',
    color: '#295EF5',
    border: '1px solid #295EF5',
    bgColor: 'transparent',
    buttonType: 'MORE'
  }
}
